import React from "react";
import Img1 from "../Images/Group 1621.png";

const EmailMarket = () => {
  return (
    <>
      <div className="email-market">
        <div className="container1">
          <div className="email-market-main">
            <div className="email-market-flex">
              <div className="email-market-img">
                <img src={Img1} alt="" />
              </div>
              <div className="email-market-content">
                <h2>
                  IF SOCIAL MEDIA IS FOR REACH, EMAIL MARKETING IS FOR REVENUE
                </h2>
                <p>
                  Imagine a dynamic marketing channel that opens a direct line
                  of communication between businesses and their valued
                  customers! This is possible through strategic email marketing
                  campaigns.
                </p>
                <p>
                  Bud & email campaigns are highly creative& vibrant channels.
                  We help you share exciting product launches, exclusive sales
                  offers, and compelling news with your targeted audience. As a
                  leading email marketing agency, coupled with our strategic
                  approach, we deliver remarkable ROI.
                </p>
                <p>
                  Gone are the days when mass mailings were sent out in a
                  scattergun fashion. Modern email marketing strategy uses the
                  power of consent, segmentation,
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailMarket;
